import styled from "styled-components";

type MainProps = {
	spotColor: number;
};

export const StyledMain = styled.main<MainProps>`
	width: 100%;
	max-width: 800px;
	margin: 0 auto;
	width: 100%;
	text-align: start;
	display: flex;
	flex-direction: column;
	gap: 30px;
	box-sizing: border-box;
	padding: 20px;
	border-radius: 10px;
	transition: 0.5s;
	background-color: var(--green50);
	border: 2px solid black;

	@media (max-width: 720px) {
		width: 95%;
		margin: 0 auto;
		text-align: center;
		padding: 10px;
	}

	h2,
	p,
	span {
		transition: 0.5s;
	}

	h2 {

		font-weight: bold;
		width: 100%;
		color: var(--orange);
		text-shadow: var(--textShadowBlack);
		display: flex;

		> p {
			font-size: 40px;
			@media (max-width: 600px) {
				font-size: 25px;
			}
			color: var(--orange);
			text-shadow: var(--textShadowBlack);
			transition: 0.2s;
			&:hover {
				color: var(--blue50);
			}

			:nth-child(${(props) => props.spotColor + 1}) {
				color: var(--blue50);
			}
		}
	}

	p {
		font-size: 20px;
		font-weight: bold;
		color: var(--white);
		text-shadow: var(--textShadowBlack);

		text-align: start;
	}

	span {
		font-size: 20px;
		font-weight: bold;
		color: var(--orange);
		text-shadow: var(--textShadowBlack);

		text-align: start;
	}

	.subtitle {
		font-size: 30px;
	}

	section {
		width: 100%;
		display: flex;
		background-color: var(--whiteSection);
		border-radius: 10px;
		position: relative;
		align-items: flex-start;

		div {
			margin-bottom: 20px;
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: 10px;
		}

		.section_div:nth-child(even) {
			border-left: 2px solid black;
		}

		.section_continue {
			position: absolute;
			bottom: 2px;
			left: 50%;
			transform: translateX(-43%);
		}
	}

	@media (max-width: 600px) {
	}
`;
